import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.17 8.055 15.157 6.87a1.7 1.7 0 0 1-.345-.945V4.65c0-.795-.652-1.448-1.447-1.448H12.09c-.3 0-.728-.157-.953-.344L9.952 1.845c-.517-.442-1.365-.442-1.882 0l-1.2 1.013a1.7 1.7 0 0 1-.945.345H4.627c-.795 0-1.447.652-1.447 1.447v1.275c0 .293-.15.713-.338.938L1.83 8.054c-.435.525-.435 1.365 0 1.875l1.012 1.193c.188.217.338.645.338.937v1.282c0 .795.652 1.448 1.447 1.448h1.305c.293 0 .72.158.945.345l1.185 1.013c.518.442 1.365.442 1.883 0l1.185-1.013a1.7 1.7 0 0 1 .945-.345h1.275c.795 0 1.447-.652 1.447-1.447v-1.275c0-.3.158-.72.345-.945l1.013-1.185c.457-.51.457-1.358.015-1.883M8.437 6.098c0-.308.255-.563.563-.563s.562.255.562.563V9.72a.567.567 0 0 1-.562.563.567.567 0 0 1-.563-.563zM9 12.653a.75.75 0 0 1-.75-.75c0-.413.33-.75.75-.75.412 0 .75.337.75.75 0 .412-.33.75-.75.75"
    }, null, -1)
  ]))]))
}
export default { render: render }